// File: cgp-user-profile-dialog-component.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile component.
// Other Contributors:

import { Component, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AuthenticationService } from '../../../app/auth.service';
import { cgpAuthentication } from '../../../modules/cgp-authentication';

@Component({
    selector: "cgp-app-bar-dialog",
    templateUrl: "./cgp-user-profile-dialog.template.html"
})
export class CgpUserProfileDialogComponent {
    @Input() title = 'User Profile';
    @Input() closeLabel = 'Close';
    ModuleDetail: any[] = [];
    userProfile: any;
    user: any;

    constructor(
        private readonly authService: AuthenticationService,
        public dialogRef: MatDialogRef<CgpUserProfileDialogComponent>
    ) {
        this.user = cgpAuthentication.getUserInfo();
        authService.getUserProfile()
            .subscribe(x => {
                this.userProfile = x;
                x['ModuleClaims'].forEach(element => {
                    this.ModuleDetail.push({
                        moduleName: element,
                        roles: [],
                    });
                });
                const bodyRoles = x['RoleClaims'].filter(x => x.indexOf('GA'));
                const gaRoles = x['RoleClaims'].filter(x => x.indexOf('Body'));
                this.ModuleDetail.forEach(veModule => {
                    veModule.moduleName === 'VE_GA' ? veModule.roles = gaRoles : veModule.roles = bodyRoles;
                });
            });
    }
}
